import Loader from '@anm/components/Loader';
import { absoluteCenter } from '@anm/styles/helpers';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { pricingSelectors } from '../../../../store/modules/pricing';

const LoaderWrapper = styled.div`
  ${absoluteCenter}
`;

const usePricingLoader = () => {
  const isPlansDataPending = !useSelector(
    pricingSelectors.selectPricingSubscriptionPlans
  );

  const spinner = useMemo(
    () =>
      isPlansDataPending ? (
        <LoaderWrapper>
          <Loader size="large2" color="blue" />
        </LoaderWrapper>
      ) : null,
    [isPlansDataPending]
  );

  return [isPlansDataPending, spinner] as const;
};

export default usePricingLoader;
